import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { articlesAPI } from "../services/api";
import Spinner from "../components/Spinner";
import { useToasts } from "../hooks/useToasts";
import {
  getRememberedTutorialLessonId,
  getPublicNotesPath,
  getTutorialSubjectsPath,
  rememberTutorialLessonId,
  selectTutorialLesson,
  TUTORIAL_ACTIONS,
} from "../constants/tutorialContent";

const TutorialNotesRedirect = () => {
  const navigate = useNavigate();
  const { addToast } = useToasts();

  useEffect(() => {
    let isMounted = true;

    const loadTutorialNotes = async () => {
      try {
        const response = await articlesAPI.getPublicArticles();
        const lessons = Array.isArray(response.data) ? response.data : [];
        const rememberedLessonId = getRememberedTutorialLessonId();
        const tutorialLesson =
          lessons.find((lesson) => lesson?._id === rememberedLessonId) ||
          selectTutorialLesson(lessons);

        if (!isMounted) return;

        if (!tutorialLesson?._id) {
          addToast("No public tutorial lesson is available yet", "error-warning");
          navigate(getTutorialSubjectsPath(TUTORIAL_ACTIONS.NOTES), {
            replace: true,
          });
          return;
        }

        rememberTutorialLessonId(tutorialLesson._id);
        navigate(getPublicNotesPath(tutorialLesson), { replace: true });
      } catch {
        if (!isMounted) return;
        addToast("Failed to load tutorial notes", "error-warning");
        navigate("/tutorial", { replace: true });
      }
    };

    loadTutorialNotes();

    return () => {
      isMounted = false;
    };
  }, [addToast, navigate]);

  return <Spinner visible={true} />;
};

export default TutorialNotesRedirect;
